module.exports = __webpack_public_path__ + "static/media/app-store.c6f60033.svg";